import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import BaseButton from "src/atoms/Button/BaseButton";

const StyledProductPhotos = styled.div<{ isInModal: boolean }>`
  width: 100%;

  :hover {
    cursor: ${({ isInModal }) => (isInModal ? "inherit" : "pointer")};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: ${({ isInModal }) => (isInModal ? "100%" : "416px")};
    margin-left: ${({ theme, isInModal }) =>
      isInModal ? "0" : theme.space[4]}px;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.colors.tone.black};
  }
`;

const StyledSwiper = styled(Swiper)<{ isclient?: string }>`
  height: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    height: ${({ isclient }) => (isclient ? "initial" : "100%")};
  }

  .swiper-wrapper {
    overflow: ${({ isclient }) => (!isclient ? "auto" : "unset")};
  }
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-width: 60%;
  }
`;

const StyledButtonNext = styled(BaseButton)`
  position: absolute;
  z-index: 2;
  cursor: pointer;
  border: none;
  background: none;
  right: ${({ theme }) => theme.space[2]}px;
  top: 50%;
  transform: rotate(270deg);

  &.swiper-button-disabled {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: none;
  }

  svg {
    width: 40px;
    fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
  }
`;

const StyledButtonBack = styled(StyledButtonNext)`
  right: unset;
  left: ${({ theme }) => theme.space[2]}px;
  transform: rotate(90deg);
`;

const StyledDotsPagination = styled.div`
  display: flex;
  justify-content: center;
  span {
    background-color: ${({ theme }) => theme.colors.tone.black};
    margin: ${({ theme }) => theme.space[3]}px
      ${({ theme }) => theme.space[2]}px;
    cursor: pointer;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: none;
  }
`;

export {
  StyledProductPhotos,
  StyledSwiper,
  StyledButtonBack,
  StyledButtonNext,
  StyledDotsPagination,
  StyledSwiperSlide,
};
